<div
	*ngIf="editMode"
	class="overlay bg-black opacity-30 fixed top-0 left-0 w-screen h-screen z-30"
></div>

<div class="flex flex-row justify-between mt-4 min-h-[40px]">
	<p class="text-[#1C252E] font-medium text-base leading-5 m-0">
		{{ 'ORGANIZATION.BRANCH.TARGET_AUDIENCE' | translate }}
	</p>
	<div
		(click)="changeEditMode()"
		class="flex gap-1 ltr:mr-6 rtl:ml-6 hover:cursor-pointer"
		*ngIf="!editMode"
	>
		<img class="w-5 max-h-5" src="assets/images/edit-blue.svg" alt="" />
		<p class="text-[#009EF7]">{{ 'ACTIONS.EDIT' | translate }}</p>
	</div>
</div>
<div
	class="flex-col custom-shadow p-24px rounded-12px bg-off-white lg:w-[776px] {{
		editMode ? 'z-40' : ''
	}} relative"
>
	<form>
		<div class="grid mobile:grid-cols-2 smMobile:grid-cols-1">
			<ng-container *ngFor="let BranchType of BranchTypes; let i = index">
				<div
					*ngIf="(types.includes(BranchType?.value) && !editMode) || editMode"
				>
					<div
						[ngClass]="{
							'border-salon': types.includes(BranchType?.value) && editMode
						}"
						class="flex-col mx-[6px] my-1 text-font-16 text-[#1C252E] py-[20px] px-[20px] border-[2px] rounded-6px max-w-[350px]"
					>
						<img
							class=""
							[ngClass]="editMode ? 'm-0' : 'm-auto mb-[6px]'"
							[src]="BranchType['icon']"
						/>
						<mat-checkbox
							*ngIf="editMode"
							(change)="branchChanged($event)"
							[disabled]="checkIfDisabled(BranchType?.value)"
							[value]="BranchType?.value"
							[checked]="types.includes(BranchType?.value)"
							class="flex mt-15px justify-end"
						></mat-checkbox>
						<p
							class="mb-[3px]"
							[ngClass]="editMode ? 'text-start mx-[5px]' : 'text-center'"
						>
							{{ 'ORGANIZATION.BRANCH.' + BranchType['name'] | translate }}
						</p>

						<!-- UNCOMMENT WHEN NEEDED -->
						<!-- <p
							class="text-start mx-[5px] text-font-14 text-medium-gray"
							*ngIf="editMode"
						>
							{{branchInformationData?.targetAudience?.[i]?.targetAudience == 1 ?"For Men's Services":"For Women's Services"}}
						</p> -->
						<!-- UNCOMMENT WHEN NEEDED -->
					</div>
					<p
						*ngIf="checkIfDisabled(BranchType?.value) && editMode"
						class="text-font-12 text-medium-gray mx-[6px] mt-[3px]"
					>
						{{ 'ORGANIZATION.BRANCH.CANT_CHANGE_TARGET_AUDIENCE' | translate }}
					</p>
				</div>
			</ng-container>
		</div>

		<mat-error
			*ngIf="!types?.length && editMode"
			class="whitespace-nowrap text-font-12 px-3"
		>
			{{
				'VALIDATION.REQUIRED'
					| translate
						: { name: 'ORGANIZATION.BRANCH.TARGET_AUDIENCE' | translate }
			}}
		</mat-error>

		<div class="flex mt-24px justify-end" *ngIf="editMode">
			<button
				(click)="changeEditMode(true)"
				class="border border-solid border-[#D9DBE9] hover:bg-gradient hover:text-off-white mx-2 text-dark-grey"
				mat-button
			>
				{{ 'ACTIONS.CANCEL' | translate }}
			</button>
			<button
				[disabled]="checkDisable()"
				(click)="saveChanges()"
				class="bg-gradient text-off-white rounded"
				mat-button
			>
				{{ 'ACTIONS.SAVE' | translate }}
			</button>
		</div>
	</form>
</div>
